var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvIconCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f58220;}.cls-4{fill:#f6c65c;}.cls-5{fill:#e11f8f;}.cls-6{fill:#5e7775;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 23.51 25.72 38.36 51.44 23.51 25.72 8.66 0 23.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,47.04H4.98c4.69,0,7.11-.9,14.75-5.22l6-3.46L0,23.51v23.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.35,7.29C12.74,1.18,10.34,0,4.98,0H0V23.51L25.72,8.66l-2.37-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.86,41.9c7.52,4.25,9.94,5.14,14.6,5.14h4.98s0-23.53,0-23.53l-25.72,14.85,6.14,3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.46,0C41.01,0,38.62,1.22,27.56,7.59l-1.84,1.06,25.72,14.85V0h-4.98Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvIconCv);
export default __webpack_public_path__ + "static/media/EnvIconCV.4818c33c7934b33b11a54a61aeeb0fd4.svg";
export { ForwardRef as ReactComponent };